export default "__VITE_ASSET__CnlK44dp__"